import { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import { Badge, DataTable, LoadState } from "layouts/finance/shared";
import { useDashboard } from "context/DashboardContext";
import FullScreenDialog from "./merchant-detail";

export default function ApprovedMerchant({ merchants, loading, error }) {
  const [selectedRow, setSelectedRow] = useState(null);
  const [visibleActionError, setVisibleActionError] = useState(null);
  const {
    fetchAllMerchant,
    merchantActionError,
    clearMerchantActionError,
  } = useDashboard();

  useEffect(() => {
    if (!merchantActionError) return undefined;

    setVisibleActionError(merchantActionError);
    const timeoutId = window.setTimeout(() => {
      setVisibleActionError(null);
      clearMerchantActionError();
    }, 5000);

    return () => window.clearTimeout(timeoutId);
  }, [merchantActionError, clearMerchantActionError]);

  useEffect(
    () => () => {
      clearMerchantActionError();
    },
    [clearMerchantActionError],
  );

  return (
    <>
      {visibleActionError && (
        <Alert severity='error' sx={{ mb: 2 }}>
          {visibleActionError}
        </Alert>
      )}
      <LoadState
        loading={loading && !merchants.length}
        error={error}
        refresh={fetchAllMerchant}
      />
      {!error && (
        <DataTable
          rowKey="merchantId"
          rows={merchants.map((row) => ({
            ...row,
            merchantId: row.merchant?.id,
          }))}
          columns={[
            { key: "merchantId", label: "Merchant ID" },
            {
              key: "name",
              label: "Business name",
              render: (row) => row.merchant?.name ?? "—",
            },
            {
              key: "userId",
              label: "User ID",
              render: (row) => row.merchant?.userId ?? "—",
            },
            {
              key: "kycLevel",
              label: "KYC level",
              render: (row) => row.merchant?.kycLevel ?? "—",
            },
            {
              key: "approved",
              label: "Approval",
              render: (row) => (
                <Badge
                  value={row.merchant?.approved ? "APPROVED" : "PENDING"}
                />
              ),
            },
            {
              key: "actions",
              label: "Review",
              render: (row) => (
                <button
                  className="table-link"
                  onClick={() => setSelectedRow(row)}
                >
                  View merchant
                </button>
              ),
            },
          ]}
        />
      )}
      {selectedRow && (
        <FullScreenDialog
          isOpen
          handleClose={() => setSelectedRow(null)}
          rowData={selectedRow}
        />
      )}
    </>
  );
}
